import Model from '@/models/Model.js';

export default class Reply extends Model {
    static entity = 'discussion_replies';

    static fields() {
        return {
            id: this.attr(null),
            thread_id: this.attr(null),
            reply_id: this.attr(null),
            activity_id: this.attr(null),
            user_id: this.attr(null),
            body: this.attr(null),

            ...super.fields(),

            thread: this.belongsTo('discussion_threads', 'thread_id'),
            parent_reply: this.belongsTo('discussion_replies', 'reply_id'),
            // activity_id: this.belongsTo('activities', 'activity_id'),
            user: this.belongsTo('users', 'user_id'),
        };
    }
}
